import React from "react";

// The tinted rounded-square tile that opens a left-column row (Settings,
// Welcome, each question, Ending). Tile only — the row stays at the call site.
const EditRowIcon = ({
  children,
  backgroundColor,
  color,
  variant,
  extraClassName,
}) => {
  const style = {};

  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
  }

  if (color) {
    style.color = color;
  }

  return (
    <div
      className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${variant ||
        "grey"} bwai-edit-row-icon ${extraClassName || ""}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default EditRowIcon;
